import { Trans } from '@lingui/react/macro';

import FoldableSection from '@/design_system/FoldableSection';
import Title from '@/design_system/Typography/Title';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { NewRequestArticles } from '@/routes/Requests/New/components/NewRequestArticles';

const Articles = () => {
  const { errors, workflow } = useRequestContext();

  return (
    <FoldableSection
      label={
        <Title as="h2">
          {workflow?.config?.fields?.request?.articles?.max === 1 ? (
            <Trans id="requests.new.articles.title.single">Item</Trans>
          ) : (
            <Trans id="requests.new.articles.title">Items</Trans>
          )}
        </Title>
      }
      isInvalid={errors.articles?.hasError}
    >
      <NewRequestArticles />
    </FoldableSection>
  );
};

export default Articles;
